import { Component, Input, OnInit } from '@angular/core';
import { GTMService } from '../../services/gtm.service';

@Component({
  selector: 'search-no-results',
  template: `
    <div class="noresultListing">
      <div *ngIf="!ownPartnershipsOnly; else ownPartners">
        <div class="header-noresult">
          <h2>Desculpe, não encontramos o local que você procura :(</h2>
        </div>
        <div class="content-noresult">
          <p>Confira se as palavras estão escritas corretamente, tente termos mais genéricos ou mude a área de busca.</p>
          <p>Você também pode convidar o local a fazer parte da rede de parcerias da Allya.</p>
        </div>
      </div>

      <ng-template #ownPartners>
        <div class="header-noresult">
          <h2>Desculpe, não encontramos nenhuma parceria própria cadastrada :(</h2>
        </div>
        <div class="content-noresult">
          <p>Para cadastrar sua primeira parceria própria clique no botão abaixo.</p>
        </div>
        <button class="btn btn-pink" [routerLink]="['/parcerias-exclusivas/cadastrar']">
          Cadastrar parceria própria
        </button>
      </ng-template>
      <div class="footer-noresult">
        <img width="304" height="305" src="../../../assets/shared/img/robot.svg" alt="">
      </div>
    </div>
  `
})

export class SearchNoResultsComponent implements OnInit {
  @Input() ownPartnershipsOnly;
  @Input() searchParams;

  constructor(private gtm: GTMService) {}

  ngOnInit(): void {
    const category = 'search';
    const action = 'searchNotFound';
    const label = String(this.searchParams).toLowerCase();

    this.gtm.interaction(category, action, label);
  }
}
